/*
  TheShapebox : comportements de la fiche produit custom.
  - Galerie : défilement par vignettes, points de pagination sur mobile.
  - Changement de variante : le prix, la barre d'achat et la photo suivent
    (événement standard productSelect émis par le sélecteur de variantes d'Horizon).
  - Barre d'achat fixe sur mobile : visible quand le bouton d'ajout au panier n'est plus à l'écran.
  Tout passe par délégation d'événements pour continuer de fonctionner
  quand l'éditeur de thème recharge la section.
*/

const GALLERY = '[data-tsb-gallery]';
const TRACK = '[data-tsb-gallery-track]';
const SLIDE = '[data-tsb-gallery-slide]';
const THUMB = '[data-tsb-gallery-thumb]';
const DOT = '[data-tsb-gallery-dot]';

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Fait défiler la galerie jusqu'à une photo.
 * @param {Element} gallery - La galerie.
 * @param {number} index - Rang de la photo.
 */
function showSlide(gallery, index) {
  const track = gallery.querySelector(TRACK);
  const slide = gallery.querySelectorAll(SLIDE)[index];
  if (!(track instanceof HTMLElement) || !(slide instanceof HTMLElement)) return;
  track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reducedMotion() ? 'auto' : 'smooth' });
}

/**
 * Met à jour vignettes et points selon la photo visible.
 * @param {Element} gallery - La galerie.
 */
function syncGallery(gallery) {
  const track = gallery.querySelector(TRACK);
  if (!(track instanceof HTMLElement) || track.clientWidth === 0) return;
  const index = Math.round(track.scrollLeft / track.clientWidth);

  gallery.querySelectorAll(THUMB).forEach((thumb, i) => {
    thumb.classList.toggle('is-active', i === index);
    if (i === index) thumb.setAttribute('aria-current', 'true');
    else thumb.removeAttribute('aria-current');
  });
  gallery.querySelectorAll(DOT).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const thumb = target.closest(THUMB);
  if (!thumb) return;
  const gallery = thumb.closest(GALLERY);
  if (!gallery) return;
  showSlide(gallery, [...gallery.querySelectorAll(THUMB)].indexOf(thumb));
});

// L'événement scroll ne remonte pas : écoute en phase de capture.
let scrollFrame = 0;
document.addEventListener(
  'scroll',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.matches(TRACK)) return;
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(() => {
      const gallery = target.closest(GALLERY);
      if (gallery) syncGallery(gallery);
    });
  },
  true
);

/**
 * Remplace les zones qui dépendent de la variante par leur version à jour.
 * @param {Element} section - La section de la fiche produit.
 * @param {Document | Element} html - Le rendu à jour de la section.
 */
function refreshVariantZones(section, html) {
  for (const zone of section.querySelectorAll('[data-tsb-refresh]')) {
    const key = zone.getAttribute('data-tsb-refresh');
    if (key === 'media') continue;
    const fresh = html.querySelector(`[data-tsb-refresh="${key}"]`);
    if (fresh) zone.innerHTML = fresh.innerHTML;
  }

  const gallery = section.querySelector(GALLERY);
  const freshGallery = html.querySelector(GALLERY);
  const mediaId = freshGallery?.getAttribute('data-featured-media-id');
  if (!gallery || !mediaId) return;
  const slides = [...gallery.querySelectorAll(SLIDE)];
  const index = slides.findIndex((slide) => slide.getAttribute('data-media-id') === mediaId);
  if (index >= 0) showSlide(gallery, index);
}

import('@shopify/events')
  .then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.productSelect, (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const section = target.closest('.shopify-section');
      if (!section || !section.querySelector('[data-tsb-product]')) return;
      event.promise
        ?.then(({ detail }) => {
          if (detail?.html) refreshVariantZones(section, detail.html);
        })
        .catch(() => {});
    });
  })
  .catch(() => {});

/** Affiche la barre d'achat quand le bouton d'ajout au panier de la page n'est pas visible. */
function observeBuyBar() {
  const bar = document.querySelector('[data-tsb-buybar]');
  const section = bar?.closest('.shopify-section');
  const button = section?.querySelector('.sb-product__buy .add-to-cart-button');
  if (!(bar instanceof HTMLElement) || !button || typeof IntersectionObserver === 'undefined') return;

  new IntersectionObserver(
    ([entry]) => {
      bar.hidden = Boolean(entry?.isIntersecting);
      document.body.classList.toggle('sb-has-buybar', !bar.hidden);
    },
    { threshold: 0.2 }
  ).observe(button);
}

observeBuyBar();
